import styled from 'styled-components';
const ResultListStyled = styled.div`
  height: 100%;
  border-radius: 12px;
  padding-top: 24px;
  padding-right: 32px;
  padding-bottom: 24px;
  padding-left: 32px;
  background-color: #fff;
  .handle_btn {
    display: flex;
    gap: 12px;
    align-items: center;
    .no-drop {
      cursor: not-allowed;
    }

    > div {
      margin-right: 15px;
    }

    .icon {
      /* fill: '#BDBDBD'; */
    }

    .preview {
      cursor: pointer;
    }
    .canClick {
      width: 18px;
      height: 18px;
      vertical-align: middle;
      /* fill: '#1B60AD'; */
      cursor: pointer;
    }
  }
  .hover {
    cursor: pointer;
    position: relative;
    display: block;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    transform: scale(1, 1);
    transition: all 0.3s;
  }
  .hover:hover {
    transform: scale(1.1, 1.1);
    transition: all 0.3s;
  }
`;
export default ResultListStyled;
